import React from "react";
import {QuickSearchResultProps} from "./@type";
import {ItemIconDict} from "../../../../../../core/gd/const/item-icon/icon/icons";



export default function SearchNoteOption(props: QuickSearchResultProps) {


    const document = props.searchResult.item

    const classes = Classes("row ui5-list-item", props.className, {
        'selected': props.searchResult.index === props.quickSearch.keyboardIterator.currentIndex,
    });

    const noteType = gd.session.noteTypes.get(document.noteTypeId);
    // const icon = noteType ? gd.const.note.icon[noteType.icon] : '';
    const icon = noteType ? ItemIconDict[noteType.icon].className : '';

    return (
        <div className={classes} onClick={props.searchResult.onClick}>
            <div className="cell">
                <div className="title">
                    <div className="icon-22 m-r-10">
                        <div className={Classes("ui5-ico-16", icon)}/>
                    </div>
                    <div className="ui5-txt-default max-w-250">{document.name}</div>
                </div>
            </div>
            <div className="cell align-r">
                <div className="ui5-property max-w-200">{gd.session.projects.get(document.projectId)?.name}</div>
            </div>
        </div>
    )
}
